var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.709 7.433H4.782l1.53-1.535a.526.526 0 1 0-.747-.743L3.154 7.573a.524.524 0 0 0-.154.38v.006c0 .183.093.344.234.438l2.331 2.337a.528.528 0 0 0 .747-.743l-1.5-1.505h10.897a4.238 4.238 0 0 1 4.236 4.23c0 2.333-1.9 4.23-4.236 4.23H3.527a.527.527 0 1 0 0 1.054H15.71A5.293 5.293 0 0 0 21 12.716a5.293 5.293 0 0 0-5.291-5.283Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.9bf2b046.svg";
export { ForwardRef as ReactComponent };